<template>
  <div id="client-detail">
    <div class="title">
      <h1>{{ $t('CLIENT_INFO') }}</h1>
      <primary-button :text="$t('BACK')" blue @click="exit()" />
    </div>

    <b-container class="wrapper">
      <b-row>
        <b-col xs="12" md="4" class="client-info">
          <client-info />
        </b-col>
        <b-col xs="12" md="8" class="main">
          <client-tab v-model='tab'/>
          <div class="panel">
            <keep-alive>
              <component :is="component"></component>
            </keep-alive>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { PATHS } from '@/consts';

import PrimaryButton from '@/components/PrimaryButton';

import ClientInfo from './ClientInfo';
import ClientTab from './ClientTab';
import NoteTab from './TabComponents/NoteTab';
import DocumentTab from './TabComponents/DocumentTab';
import BankAccountInfomationTab from './TabComponents/BankAccountInfomationTab';
import ContractTab from './TabComponents/ContractTab';
import TAB_NAMES from './TabComponents/tabs';

const { useState, useActions } = createNamespacedHelpers('clientDetail');
const { useState: useStateApp } = createNamespacedHelpers('app');

export default {
  name: 'ClientDetail',
  components: {
    FontAwesomeIcon,
    ClientInfo,
    ClientTab,
    NoteTab,
    DocumentTab,
    BankAccountInfomationTab,
    ContractTab,
    PrimaryButton
  },

  metaInfo() {
    const { $root: { $route } } = this;
    const title = `Client #${$route.params.id}`;

    return {
      title,
      meta: []
    };
  },
  setup(props, { root }) {
    const { isDesktop } = useStateApp(['isDesktop']);
    const { targetingClient: client } = useState(['targetingClient']);
    const { setCheckContract, getContracts } = useActions(['setCheckContract', 'getContracts']);

    const tab = ref('CONTRACTS');
    const showContractClose = ref(false);

    const component = computed(() => {
      switch (tab.value) {
        case TAB_NAMES.CONTRACTS:
          return 'contract-tab';
        case TAB_NAMES.DOCUMENT:
          return 'document-tab';
        case TAB_NAMES.BANK_ACCOUNT_INFOMATION:
          return 'bank-account-infomation-tab';
        case TAB_NAMES.NOTES:
          return 'note-tab';
        case TAB_NAMES.CLIENT_INFO:
          return 'client-info';
        default:
          return 'contract-tab';
      }
    });

    const exit = () => { root.$router.push(PATHS.CLIENTS); };

    watch(tab, () => {
      if (tab.value === TAB_NAMES.CONTRACT_CLOSE) {
        showContractClose.value = true;

        setCheckContract(showContractClose.value);
      } else if (tab.value === TAB_NAMES.CONTRACT_ACTIVE) {
        showContractClose.value = false;

        setCheckContract(showContractClose.value);
      }
    });

    watch(isDesktop, () => {
      tab.value = TAB_NAMES.CONTRACT_ACTIVE;
    });

    watch(client, () => {
      getContracts();
    });

    onMounted(() => {
      setCheckContract(showContractClose.value);
    });
    return {
      exit,
      faTimes,
      tab,
      component,
      showContractClose,
      isDesktop
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#client-detail {
  padding: 30px 0;

  .title {
    margin-bottom: 20px;
    margin-left: 20px;

    h1 {
      display: inline-block;
      font-size: 28px;
      vertical-align: middle;
    }

    .primary-button {
      display: inline-block;
      border-radius: 4px;
      margin-left: 20px;
      vertical-align: middle;
    }
  }

  .client-info {
    margin-right: -12px;
  }

  .wrapper {
    margin: 0;

    .main {
      display: flex;
      flex-flow: column;

      .panel {
        flex-grow: 1;
        background-color: $babyPowder;
        border-radius: 4px;
      }
    }
  }

  @media (max-width: 991px) {
    padding: 15px;
  }
}
</style>
